declare namespace $ {

	type $shm_echarts__option_shm_ba_chart_tags_1 = $mol_type_enforce<
		ReturnType< $shm_ba_chart_tags['option'] >
		,
		ReturnType< $shm_echarts['option'] >
	>
	export class $shm_ba_chart_tags extends $mol_view {
		option( ): any
		Chart( ): $shm_echarts
		rows( ): readonly(any)[]
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=tags.view.tree.d.ts.map